import {useEffect} from 'react'

import CommentGroup from './CommentGroup.js'
import {useSelector} from '../../../../store.js'

/**
 * A comment timeline
 *
 * @param {Object} props
 * @param {Function} props.commentGroupsSelector
 * @param {Function} props.ensureComments
 * @param {Function} props.addComment
 * @param {Boolean} [props.readOnly]
 * @returns {React.ReactNode}
 */
export default function Timeline({
  readOnly,
  addComment,
  commentGroupsSelector,
  ensureComments,
}) {
  const commentGroups = useSelector(commentGroupsSelector)

  useEffect(() => {
    ensureComments()
  }, [commentGroups.length === 0])

  return (
    <div>
      <h3 className="list__title--order-data margin-top-0 margin-bottom-5">
        Timeline
      </h3>
      <button
        className="btn btn--link fs-n1 margin-bottom-15"
        type="button"
        onClick={() => addComment()}
        disabled={readOnly}
      >
        Add a comment
      </button>

      {commentGroups.length === 0 && (
        <div className="loading align-left margin-bottom-20">
          <span className="spinner--md v-align-middle" />
          <em className="inline-block v-align-middle fs-n0 op-75 margin-left-5">
            Loading timeline...
          </em>
        </div>
      )}
      {commentGroups.map(({day, comments}) => (
        <CommentGroup key={day} day={day} comments={comments} />
      ))}
    </div>
  )
}
